module.exports = __webpack_public_path__ + "img/fashion_46.eb03353f.jpg";